export const MODE = import.meta.env.MODE;
export const PUBLIC_DSN = import.meta.env.VITE_PUBLIC_DSN;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const API_URL = import.meta.env.VITE_API_URL;
export const APPLICATION_IDENTIFIER = import.meta.env
  .VITE_APPLICATION_IDENTIFIER;
export const STRIPE_PRODUCTS = import.meta.env.VITE_STRIPE_PRODUCTS;
export const STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY;
export const STRIPE_ACCOUNT = import.meta.env.VITE_STRIPE_ACCOUNT;
export const SUPPORT_API_URL =
  import.meta.env.VITE_SUPPORT_API_URL ||
  // production value by default
  "https://api.simplybroadband.co.nz";
